import { useTranslation } from 'react-i18next';

import { AssetsService } from '../../../services/AssetsService';

import {
  StyledContactUsImage,
  StyledContactUsModalContainer,
  StyledContactUsSubTitle,
  StyledContactUsTitle,
} from './styles';

export const ContactUsSuccessModal = () => {
  const { t } = useTranslation();

  return (
    <StyledContactUsModalContainer>
      <StyledContactUsImage src={AssetsService.assetUrl('/images/balloons.svg')} alt="balloons" />
      <StyledContactUsTitle>{t('hook.contact_us.title')}</StyledContactUsTitle>
      <StyledContactUsSubTitle>{t('hook.contact_us.subtitle')}</StyledContactUsSubTitle>
    </StyledContactUsModalContainer>
  );
};
